import { render } from "./WorkingSitePpes.vue?vue&type=template&id=e6631d46&scoped=true&ts=true&lang=pug"
import script from "./WorkingSitePpes.vue?vue&type=script&lang=ts"
export * from "./WorkingSitePpes.vue?vue&type=script&lang=ts"

import "./WorkingSitePpes.vue?vue&type=style&index=0&id=e6631d46&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6631d46"]])

export default __exports__